var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input-text',_vm._g(_vm._b({on:{"keypress":_vm.onlyNumber},model:{value:(_vm.numberValue),callback:function ($$v) {_vm.numberValue=$$v},expression:"numberValue"}},'base-input-text',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }